import { initFirebase } from './firebase-messaging.js';
import { handleForegroundMessages } from './handlers.js';
import { requestNotificationPermission } from './permissions.js';

/**
 * Register Service Worker
 */
async function registerServiceWorker() {
	if ('serviceWorker' in navigator) {
		try {
			// Register Firebase Service Worker
			const registration = await navigator.serviceWorker.register(`${wpcore.themePath}/assets/firebase/firebase-messaging-sw.js`);

			// Check permission state
			if (Notification.permission === 'default') {
				const { showNotificationPermissionModal } = await import('./fcm-modal.js');
				showNotificationPermissionModal(() => {
					requestNotificationPermission(registration);
				});
			} else {
				// If already granted, proceed to get token
				requestNotificationPermission(registration);
			}
		} catch (error) {
			console.error('Service Worker registration failed:', error);
		}
	} else {
		console.warn('Service Workers not supported in this browser');
	}
}

/**
 * Main Firebase module entry point
 * Coordinates initialization, service worker registration, and message handling
 */
export async function initFirebaseConfig() {
	try {
		// 1. Initialize Firebase App and Messaging
		const initialized = await initFirebase();

		if (initialized) {
			// 2. Register Service Worker and request permissions (Self-contained logic)
			await registerServiceWorker();

			// 3. Set up foreground message listeners
			handleForegroundMessages();
		}
	} catch (error) {
		console.error('Failed to bootstrap Firebase module:', error);
	}
}

